import { urlForImage } from 'lib/sanity.image'

import { ResponsiveImage } from 'components/Global/ResponsiveImage'
import { Hotspots } from 'components/Global/Hotspots'

export const ThreeUpTag = ({ layout = 'full', items }) => {
  const layoutClasses = layout === 'full' ? 'w-full p-0' : 'w-full p-20 gap-20'
  return (
    <div className={`grid md:grid-cols-3 ${layoutClasses}`}>
      {items.map((item) => {
        const url = urlForImage(item.image).width(800).auto('format').url()
        return (
          <div
            key={item._key}
            className={`relative overflow-hidden ${
              layout === 'full' ? '' : 'rounded-12'
            }`}
            style={{ aspectRatio: `2/3` }}
          >
            <Hotspots spots={item.hotspots} />
            <ResponsiveImage src={url} alt={item.image.alt} />
          </div>
        )
      })}
    </div>
  )
}
